import { SyntheticEvent, useState } from 'react'

import Slider, { SliderProps } from '@mui/material/Slider'
import { styled } from '@mui/material/styles'

const StyledSlider = styled(Slider)(({ theme }) => ({
  color: '#ba8d26',
  height: 5,
  padding: '15px 0',
  '& .MuiSlider-thumb': {
    height: 20,
    width: 20,
    backgroundColor: '#fff',
    boxShadow: '0 0 2px 0px rgba(0, 0, 0, 0.1)',
    '&:focus, &:hover, &.Mui-active': {
      boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.1)',
      // Reset on touch devices, it doesn't add specificity
      // '@media (hover: none)': {
      //   boxShadow: iOSBoxShadow,
      // },
    },
    '&:before': {
      boxShadow:
        '0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)',
    },
  },
  '& .MuiSlider-valueLabel': {
    fontSize: 12,
    fontWeight: 'normal',
    top: -6,
    backgroundColor: 'unset',
    color: theme.palette.text.primary,
    '&::before': {
      display: 'none',
    },
    '& *': {
      background: 'transparent',
      color: '#000',
      ...theme.applyStyles('dark', {
        color: '#fff',
      }),
    },
  },
  '& .MuiSlider-track': {
    border: 'none',
    height: 5,
  },
  '& .MuiSlider-rail': {
    opacity: 0.5,
    boxShadow: 'inset 0px 0px 4px -2px #000',
    backgroundColor: '#d0d0d0',
  },
  ...theme.applyStyles('dark', {
    color: '#c6982d',
  }),
}))

interface RangeSliderComponentProps extends Omit<
  SliderProps,
  'value' | 'onChange'
> {
  id: string
  modal: boolean
  onChange: Function
  value: number[]
}

// Button is only displayed when not in a modal.
// On mobile, change is directly triggered.
export default function RangeSlider({
  min,
  max,
  modal,
  onChange,
  value: initialValue,
}: RangeSliderComponentProps) {
  const [value, setValue] = useState<number[]>(initialValue)
  const unchanged =
    value &&
    initialValue &&
    value[0] === initialValue[0] &&
    value[1] === initialValue[1]

  return (
    <div className='c-filter__range'>
      <StyledSlider
        min={min}
        max={max}
        value={value}
        onChange={pendingChange}
        valueLabelDisplay='on'
        aria-labelledby='range-slider'
        getAriaValueText={(val: any) => formatText(val[0])}
        valueLabelFormat={formatText}
      />
      {!modal && (
        <button
          className='c-btn c-btn--secondary c-btn--small u-hidden@us'
          onClick={validateChange}
          disabled={unchanged}
        >
          Valider
        </button>
      )}
    </div>
  )

  function formatText(value: any) {
    return `${value}€`
  }

  function validateChange(event: SyntheticEvent) {
    event.preventDefault()
    handleChange(value)
  }

  function handleChange(value: any) {
    onChange({
      label: `de ${value[0]}€ à ${value[1]}€`,
      value,
    })
  }

  // Change value without triggering search
  function pendingChange(_event: Event, value: any) {
    setValue(value)

    if (modal) {
      handleChange(value)
    }
  }
}
